import ProductChip from "./productChip.container";
export default ProductChip;
